// TODO: Make this dynamic
import { wei } from '@kwenta/wei';
import { FuturesMarketAsset, FuturesMarketKey, PerpsProvider, SnxV3NetworkIds, SupportedNetworkIds, } from '../types/index.js';
import { SynthAssetKeysV3 } from '../types/index.js';
import { MarketAssetByKey, MarketKeyByAsset, chainToV3Provider, inverseObj, } from '../utils/index.js';
import { COLLATERAL_PYTH_IDS, PERPS_PYTH_IDS, V3_WRAPPED_TOKEN_MARKETS } from './futures.js';
export const V3_PERPS_MARKET_IDS = {
    [PerpsProvider.SNX_V3_BASE]: {
        [FuturesMarketKey.sETHPERP]: '100',
        [FuturesMarketKey.sBTCPERP]: '200',
        [FuturesMarketKey.sSNXPERP]: '300',
        [FuturesMarketKey.sSOLPERP]: '400',
        [FuturesMarketKey.sWIFPERP]: '500',
        [FuturesMarketKey.sWPERP]: '600',
        [FuturesMarketKey.sENAPERP]: '700',
        [FuturesMarketKey.sDOGEPERP]: '800',
        [FuturesMarketKey.sAVAXPERP]: '900',
        [FuturesMarketKey.sOPPERP]: '1000',
        [FuturesMarketKey.sORDIPERP]: '1100',
        [FuturesMarketKey.sPEPEPERP]: '1200',
        [FuturesMarketKey.sRUNEPERP]: '1300',
        [FuturesMarketKey.sBONKPERP]: '1400',
        [FuturesMarketKey.sFTMPERP]: '1500',
        [FuturesMarketKey.sARBPERP]: '1600',
        [FuturesMarketKey.sPOLPERP]: '1700',
        [FuturesMarketKey.sBNBPERP]: '1800',
        [FuturesMarketKey.sLINKPERP]: '1900',
        [FuturesMarketKey.sPENDLEPERP]: '2000',
        [FuturesMarketKey.sINJPERP]: '2100',
        [FuturesMarketKey.sGMXPERP]: '2200',
        [FuturesMarketKey.sTIAPERP]: '2300',
        [FuturesMarketKey.sSUIPERP]: '2400',
        [FuturesMarketKey.sTONPERP]: '2500',
        [FuturesMarketKey.sARKMPERP]: '2600',
        [FuturesMarketKey.sGALAPERP]: '2700',
        [FuturesMarketKey.sTAOPERP]: '2800',
        [FuturesMarketKey.sBOMEPERP]: '2900',
        [FuturesMarketKey.sETHFIPERP]: '3000',
        [FuturesMarketKey.sSTXPERP]: '3100',
        [FuturesMarketKey.sAXLPERP]: '3200',
        [FuturesMarketKey.sAAVEPERP]: '3300',
        [FuturesMarketKey.sADAPERP]: '3400',
        [FuturesMarketKey.sALGOPERP]: '3500',
        [FuturesMarketKey.sAPTPERP]: '3600',
        [FuturesMarketKey.sATOMPERP]: '3700',
        [FuturesMarketKey.sAXSPERP]: '3800',
        [FuturesMarketKey.sBALPERP]: '3900',
        [FuturesMarketKey.sBCHPERP]: '4000',
        [FuturesMarketKey.sBLURPERP]: '4100',
        [FuturesMarketKey.sCOMPPERP]: '4200',
        [FuturesMarketKey.sCRVPERP]: '4300',
        [FuturesMarketKey.sDOTPERP]: '4400',
        [FuturesMarketKey.sDYDXPERP]: '4500',
        [FuturesMarketKey.sEOSPERP]: '4600',
        [FuturesMarketKey.sETCPERP]: '4700',
        [FuturesMarketKey.sETHBTCPERP]: '4800',
        [FuturesMarketKey.sFILPERP]: '4900',
        [FuturesMarketKey.sFLOWPERP]: '5000',
        [FuturesMarketKey.sFXSPERP]: '5100',
        [FuturesMarketKey.sGRTPERP]: '5200',
        [FuturesMarketKey.sICPPERP]: '5300',
        [FuturesMarketKey.sIMXPERP]: '5400',
        [FuturesMarketKey.sJTOPERP]: '5500',
        [FuturesMarketKey.sJUPPERP]: '5600',
        [FuturesMarketKey.sLDOPERP]: '5700',
        [FuturesMarketKey.sLTCPERP]: '5800',
        [FuturesMarketKey.sMEMEPERP]: '6000',
        [FuturesMarketKey.sNEARPERP]: '6100',
        [FuturesMarketKey.sPYTHPERP]: '6200',
        [FuturesMarketKey.sRNDRPERP]: '6300',
        [FuturesMarketKey.sSEIPERP]: '6400',
        [FuturesMarketKey.sSHIBPERP]: '6500',
        [FuturesMarketKey.sSTRKPERP]: '6600',
        [FuturesMarketKey.sSUSHIPERP]: '6700',
        [FuturesMarketKey.sTRXPERP]: '6800',
        [FuturesMarketKey.sUNIPERP]: '6900',
        [FuturesMarketKey.sXLMPERP]: '7000',
        [FuturesMarketKey.sXRPPERP]: '7100',
        [FuturesMarketKey.sYFIPERP]: '7200',
        [FuturesMarketKey.sEIGENPERP]: '7300',
        [FuturesMarketKey.sIOPERP]: '7400',
        [FuturesMarketKey.sMEWPERP]: '7500',
        [FuturesMarketKey.sMKRPERP]: '7600',
        [FuturesMarketKey.sNOTPERP]: '7700',
        [FuturesMarketKey.sPEOPLEPERP]: '7800',
        [FuturesMarketKey.sPOPCATPERP]: '8000',
        [FuturesMarketKey.sRENDERPERP]: '8100',
        [FuturesMarketKey.sSATSPERP]: '8200',
        [FuturesMarketKey.sWLDPERP]: '8300',
        [FuturesMarketKey.sZROPERP]: '8400',
        [FuturesMarketKey.sSAFEPERP]: '8500',
        [FuturesMarketKey.sGOATPERP]: '8600',
        [FuturesMarketKey.sMOODENGPERP]: '8700',
        [FuturesMarketKey.sPNUTPERP]: '8800',
        [FuturesMarketKey.sCATPERP]: '8900',
        [FuturesMarketKey.sDEGENPERP]: '9000',
        [FuturesMarketKey.sSLERFPERP]: '9100',
        [FuturesMarketKey.sMORPHOPERP]: '9200',
        [FuturesMarketKey.sCHILLGUYPERP]: '9300',
        [FuturesMarketKey.sAEROPERP]: '9400',
        [FuturesMarketKey.sSOLETHPERP]: '9500',
        [FuturesMarketKey.sPENGUPERP]: '9600',
        [FuturesMarketKey.sVIRTUALPERP]: '9700',
        [FuturesMarketKey.sKMNOPERP]: '9800',
        [FuturesMarketKey.sFARTCOINPERP]: '9900',
        [FuturesMarketKey.sTRUMPPERP]: '10000',
        [FuturesMarketKey.sMELANIAPERP]: '10100',
        [FuturesMarketKey.sSPERP]: '10200',
        [FuturesMarketKey.sVVVPERP]: '10300',
        [FuturesMarketKey.sVELOPERP]: '10400',
        [FuturesMarketKey.sBERAPERP]: '10500',
        [FuturesMarketKey.sIPPERP]: '10600',
        [FuturesMarketKey.sOMPERP]: '10700',
        [FuturesMarketKey.sKAITOPERP]: '10800',
    },
};
export const V3_SYNTH_KEYS_BASE = Object.keys(V3_WRAPPED_TOKEN_MARKETS[SupportedNetworkIds.BASE_MAINNET]);
export const V3_SYNTH_KEYS = [...new Set([...V3_SYNTH_KEYS_BASE])];
export const V3_PERPS_MARKET_IDS_TO_KEYS = {
    [PerpsProvider.SNX_V3_BASE]: inverseObj(V3_PERPS_MARKET_IDS[PerpsProvider.SNX_V3_BASE]),
};
export const v3PerpsMarketIdToAssetKey = (chainId, marketId) => {
    const key = V3_PERPS_MARKET_IDS_TO_KEYS[chainToV3Provider(chainId)][marketId];
    return MarketAssetByKey[key];
};
export const v3MarketIdByMarketAsset = (_chainId, asset) => {
    const key = MarketKeyByAsset[asset];
    return V3_PERPS_MARKET_IDS[PerpsProvider.SNX_V3_BASE][key];
};
export const v3SynthIdToKey = (id, chainId) => {
    const record = V3_WRAPPED_TOKEN_MARKETS[chainId];
    const mapping = inverseObj(record);
    if (chainId === SnxV3NetworkIds.BASE_MAINNET || chainId === SnxV3NetworkIds.BASE_SEPOLIA) {
        mapping[0] = SynthAssetKeysV3.sUSDC;
    }
    return mapping[id];
};
export const assetToTokenTicker = (asset) => {
    if (asset.startsWith('s'))
        return asset.slice(1);
    return asset;
};
export const tokenTickerToPriceAsset = (token) => {
    switch (token) {
        case 'WETH':
        case 'ETH':
            return FuturesMarketAsset.sETH;
        case 'scbETH':
        case 'cbETH':
            return 'cbETH';
        case 'scbBTC':
        case 'cbBTC':
            return 'cbBTC';
        case 'wstETH':
        case 'swstETH':
            return 'wstETH';
        case 'SUSD':
            return 'sUSD';
    }
    return token;
};
export const ORDERS_KEEPER_ADDRESSES = {
    84532: '0x1d1159B33a1b2A5b34B7E8A0300d1b6335bF51A1',
    8453: '0x1d1159B33a1b2A5b34B7E8A0300d1b6335bF51A1',
};
export const KWENTA_PERPS_V3_REFERRAL_ADDRESS = {
    [PerpsProvider.SNX_V3_BASE]: '0x3bD64247d879AF879e6f6e62F81430186391Bdb8',
};
export var DepositableV3AssetsBase;
(function (DepositableV3AssetsBase) {
    DepositableV3AssetsBase["USDC"] = "USDC";
    DepositableV3AssetsBase["WETH"] = "WETH";
    DepositableV3AssetsBase["ETH"] = "ETH";
    DepositableV3AssetsBase["cbETH"] = "cbETH";
    DepositableV3AssetsBase["cbBTC"] = "cbBTC";
    DepositableV3AssetsBase["wstETH"] = "wstETH";
})(DepositableV3AssetsBase || (DepositableV3AssetsBase = {}));
export const DepositableAssetKeysV3 = { ...DepositableV3AssetsBase };
export const WRAP_SLIPPAGE_MULTIPLIER = 0.999;
export const ZAP_LOAN_BUFFER = wei(1);
export const predefinedOracles = (chainId, assets) => {
    const provider = chainToV3Provider(chainId);
    const marketIds = Object.values(V3_PERPS_MARKET_IDS[provider]);
    const marketFeeds = marketIds.reduce((acc, marketId) => {
        const asset = v3PerpsMarketIdToAssetKey(chainId, marketId);
        const pythId = PERPS_PYTH_IDS[asset];
        const includeAsset = !assets || assets.includes(asset);
        if (pythId && includeAsset)
            acc.push(pythId);
        return acc;
    }, []);
    const collateralFeeds = assets?.reduce((acc, asset) => {
        const pythId = COLLATERAL_PYTH_IDS[asset];
        if (pythId)
            acc.push(pythId);
        return acc;
    }, []) ?? [];
    return [...new Set([...marketFeeds, ...collateralFeeds])];
};
// We've been instructed to only use the strategy id 0 for now
export const DEFAULT_SETTLEMENT_STRATEGY_ID = 0;
export const TYPED_ORDER_DATA = {
    OrderDetails: [
        { name: 'marketId', type: 'uint128' },
        { name: 'accountId', type: 'uint128' },
        { name: 'sizeDelta', type: 'int128' },
        { name: 'settlementStrategyId', type: 'uint128' },
        { name: 'acceptablePrice', type: 'uint256' },
        { name: 'isReduceOnly', type: 'bool' },
        { name: 'trackingCode', type: 'bytes32' },
        { name: 'referrer', type: 'address' },
    ],
    ConditionalOrder: [
        { name: 'orderDetails', type: 'OrderDetails' },
        { name: 'signer', type: 'address' },
        { name: 'nonce', type: 'uint256' },
        { name: 'requireVerified', type: 'bool' },
        { name: 'trustedExecutor', type: 'address' },
        { name: 'maxExecutorFee', type: 'uint256' },
        { name: 'conditions', type: 'bytes[]' },
    ],
};
//# sourceMappingURL=perpsv3.js.map